import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { PRODUCT } from '../../../../../routes/paths';
import {
    asyncGetProduct,
    asyncGetProductHistorical,
} from '../../../../../services/product.service';
import {
    Product,
    ProductHistorical,
} from '../../../../../shared/types/systemConfiguration/products';

export const useProductDetail = () => {
    const [showHistorical, setShowHistorical] = useState(false);
    const navigate = useNavigate();
    const { idProduct } = useParams();
    const [loading, setLoading] = useState(false);
    const [product, setProduct] = useState<Product>();
    const [productHistorical, setProductHistorical] =
        useState<ProductHistorical[]>();

    useEffect(() => {
        if (Boolean(idProduct)) {
            setLoading(true);
            asyncGetProduct(idProduct)
                .then((product) => {
                    if (product) setProduct(product);
                    else navigate(PRODUCT);
                })
                .finally(() => setLoading(false));
        }
    }, [idProduct]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            asyncGetProductHistorical(idProduct)
                .then((resp) => {
                    if (resp) setProductHistorical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        loading,
        product,
        productHistorical,
        showHistorical,
        setShowHistorical,
    };
};
